import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M17.1877 9.82857C17.1877 8.54795 16.8679 7.31979 15.976 6.41426C15.0841 5.50872 13.8744 5 12.6131 5C11.3517 5 10.1421 5.50872 9.25015 6.41426C8.35825 7.31979 8.0385 8.54795 8.0385 9.82857C8.0385 12.6894 6.98019 14.7519 6.33051 16.0892C5.96712 16.8372 6.50554 18 7.31051 18H17.9205C18.7255 18 19.2639 16.8372 18.9005 16.0892C18.2508 14.7519 17.1877 12.6894 17.1877 9.82857Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M14.25 20C14.0722 20.3042 13.8169 20.5566 13.5098 20.7321C13.2026 20.9076 12.8544 21 12.5 21C12.1456 21 11.7974 20.9076 11.4902 20.7321C11.1831 20.5566 10.9278 20.3042 10.75 20",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M13.5 3H11.5",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }